export const addForwardslashToLinks = link => {
    if (link.charAt(link.length - 1) === "/") {
        return link
    } else {
        return link + "/"
    }
}

export const getGtmUserType = () => {
    let gtmUserType = "NewUser"

    if (
        typeof localStorage !== "undefined" &&
        localStorage.getItem("recentSearches")
    ) {
        gtmUserType = "ReturnNonPersonalizedUser"
    }

    return gtmUserType
}

export const fireGtmEvent = obj => {
    if (typeof window !== "undefined") {
        window.gtmDataLayer = window.gtmDataLayer || []
        window.gtmDataLayer.push(obj)
    }
}

export const changeGtmParametersValue = (parameters, index) => {
    let userType = getGtmUserType()
    let gtmParameter = parameters

    if (gtmParameter.includes(`'`)) {
        gtmParameter = gtmParameter.split(`'`).join(`"`);
    }
    if (gtmParameter.includes('{{user}}')) {
        gtmParameter = gtmParameter.split(`{{user}}`).join(userType);
    }
    if (gtmParameter.includes('{{carroouselwidgetorder}}')) {
        gtmParameter = gtmParameter.split(`{{carroouselwidgetorder}}`).join(index);
    }

    return JSON.parse(gtmParameter)
}